module.exports = __webpack_public_path__ + "static/media/mv_active.1e18aa13.jpg";